module.exports = __webpack_public_path__ + "img/icon-calendar.8d4d3e54.png";